module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/conscientiousness/d53047fda6014452d3f41bcb24b32ee9.png";